export const NEAR_BOTTOM_THRESHOLD = 20
export const MAX_BROADCASTER_CHAT_HISTORY = 1000
export const APP_PANEL_MIN_ELAPSED_MESSAGES = 20
